import React from 'react';

const SubFlowFooter = ({ onClose, onSave, saveText, cancelText }) => [
    <button
        className="btn btn-default btn-outline flex-child-right"
        onClick={onClose}
    >
        {cancelText}
    </button>,
    <button
        className="btn btn-primary margin-left"
        onClick={onSave}
    >
        {saveText}
    </button>,
];

export default SubFlowFooter;
